import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalConstants {
    public DUMMY_IDF = "9999910";
    public DUMMY_VZ = 51;
}
